// extracted by mini-css-extract-plugin
export var container = "_4v-0";
export var icon = "_4v-1";
export var text = "_4v-2";